import React, { useEffect, useMemo, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./styles.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainRouter from "./MainRouter";
import { BrowserRouter } from "react-router-dom";

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === "dark"
      ? {
          background: { default: "#000000", paper: "#111111" },
          text: { primary: "#ffffff", secondary: "rgba(255,255,255,0.7)" },
          divider: "rgba(255,255,255,0.2)",
          primary: { main: "#ffffff" },
          secondary: { main: "#4D96FF" },
        }
      : {
          background: { default: "#fafafa", paper: "#ffffff" },
          text: { primary: "#111111", secondary: "rgba(0,0,0,0.7)" },
          divider: "rgba(0,0,0,0.12)",
          primary: { main: "#2A2A2A" },
          secondary: { main: "#1976d2" },
        }),
  },
  shape: { borderRadius: 25 },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: "none", borderRadius: 25 } },
    },
  },
});

export default function App() {
  const [mode, setMode] = useState(
    () => localStorage.getItem("app_theme") || "dark"
  );

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem("app_theme", mode);
  }, [mode]);

  const toggleTheme = () =>
    setMode((m) => (m === "dark" ? "light" : "dark"));

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        
        {/* ⭐ REAL SCROLL CONTAINER — IMPORTANT */}
        <div data-scroll-container style={{ height: "100vh", overflowY: "auto" }}>
          <MainRouter themeMode={mode} onToggleTheme={toggleTheme} />
        </div>

        <ToastContainer
          position="top-right"
          autoClose={15000}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          style={{ zIndex: 99999 }}
        />
      </ThemeProvider>
    </BrowserRouter>
  );
}
